(function (Drupal, once) {
  Drupal.behaviors.hslScrollHorizontalGrid = {
    attach(context) {
      if (typeof window === "undefined") {
        return;
      }

      once(
        "hsl-scroll-horizontal-grid-content",
        ".hsl-scroll-horizontal-grid-content",
        context,
      ).forEach((grid) => {
        let isPointerDown = false;
        let isDragging = false;
        let suppressClick = false;
        let startX = 0;
        let startScrollLeft = 0;

        const dragThreshold = 4;
        const interactiveSelector =
          "a, button, input, textarea, select, iframe, label, summary, [role='button'], [contenteditable='true']";

        const updateDraggableState = () => {
          const isDraggable = grid.scrollWidth > grid.clientWidth;
          grid.classList.toggle("is-draggable", isDraggable);
        };

        const endDrag = (pointerId) => {
          if (isPointerDown && pointerId !== undefined) {
            try {
              grid.releasePointerCapture(pointerId);
            } catch (error) {}
          }

          suppressClick = isDragging;
          isPointerDown = false;
          isDragging = false;
          grid.classList.remove("is-dragging");

          if (suppressClick) {
            window.setTimeout(() => {
              suppressClick = false;
            }, 0);
          }
        };

        grid.addEventListener("pointerdown", (event) => {
          if (event.button !== 0 || event.pointerType === "touch") {
            return;
          }

          if (event.target.closest(interactiveSelector)) {
            return;
          }

          updateDraggableState();
          if (!grid.classList.contains("is-draggable")) {
            return;
          }

          isPointerDown = true;
          isDragging = false;
          startX = event.clientX;
          startScrollLeft = grid.scrollLeft;
          grid.setPointerCapture(event.pointerId);
          event.preventDefault();
        });

        grid.addEventListener("pointermove", (event) => {
          if (!isPointerDown) {
            return;
          }

          const deltaX = event.clientX - startX;

          if (!isDragging && Math.abs(deltaX) > dragThreshold) {
            isDragging = true;
            grid.classList.add("is-dragging");
          }

          if (isDragging) {
            grid.scrollLeft = startScrollLeft - deltaX;
            event.preventDefault();
          }
        });

        grid.addEventListener("pointerup", (event) => {
          endDrag(event.pointerId);
        });

        grid.addEventListener("pointercancel", (event) => {
          endDrag(event.pointerId);
        });

        grid.addEventListener("lostpointercapture", () => {
          endDrag();
        });

        grid.addEventListener("dragstart", (event) => {
          if (event.target.closest(interactiveSelector)) {
            return;
          }

          event.preventDefault();
        });

        grid.addEventListener("selectstart", (event) => {
          if (!isPointerDown) {
            return;
          }

          event.preventDefault();
        });

        grid.addEventListener(
          "click",
          (event) => {
            if (!suppressClick) {
              return;
            }

            event.preventDefault();
            event.stopPropagation();
          },
          true,
        );

        if (typeof ResizeObserver !== "undefined") {
          const resizeObserver = new ResizeObserver(updateDraggableState);
          resizeObserver.observe(grid);
        }

        updateDraggableState();
      });
    },
  };
})(Drupal, once);
